export default "__VITE_PUBLIC_ASSET__eeb269b9__"